import { TInitializationProps } from '@r1-frontend/service-engineer-visit/actions/thunk/initialization';
import DateOfServiceEngineerVisit
    from '@r1-frontend/service-engineer-visit/containers/DateOfServiceEngineerVisit';
import ContextProvider from '@r1-frontend/service-engineer-visit/context/Context';
import { TDeliveryOption } from '@r1-frontend/service-engineer-visit/types/TDeliveryOption';
import { TGetTimeSlots } from '@r1-frontend/service-engineer-visit/types/TGetTimeSlots';
import { TReturnType } from '@r1-frontend/service-engineer-visit/types/TReturnType';

type TDeliveryTypeProps = {
    onDeliveryOptionSelected?: (deliveryOption: TDeliveryOption) => void,
    deliveryOptions: TDeliveryOption[],
} | {
    onDeliveryOptionSelected?: never,
    deliveryOptions?: never,
};

export type TProps = {
    onConfirm: (result: TReturnType | null, msg?: string) => void,
    onClickConfirm: () => void, // TODO, требуется другое решение. (сейчас используется для отправки события клика по кнопке подтвердить в аналитику)
    getTimeSlotsFunc: TGetTimeSlots,
    onUpdateLoading?: () => void,
    withComment?: boolean,
    domain: string,
}

type DateOfServiceEngineerVisitContainerWithAgreementIdProps =
    TProps
    & TDeliveryTypeProps
    & Omit<TInitializationProps, 'deliveryOptions'>;

const DateOfServiceEngineerVisitWrapper = (props: DateOfServiceEngineerVisitContainerWithAgreementIdProps) => {
    return (
        <ContextProvider>
            <DateOfServiceEngineerVisit {...props} />
        </ContextProvider>
    );
};

export default DateOfServiceEngineerVisitWrapper;
